import React from 'react'

import './AdminViewInforPage.css'

const AdminViewInforPage = () => {
   return <div>Admin View Infor Page</div>
}

export default AdminViewInforPage
